const RECOMMEND_ERROR_MESSAGES: Record<string, string> = {
  APP_RECIPIENT_UNAVAILABLE: 'У клиента пока нет доступного чата в Рекомендуй.',
  IDENTITY_UNVERIFIED: 'Пользователю нужно подтвердить номер в «Рекомендуй».',
  CRM_RELATION_REQUIRED: 'Пользователь не связан с клиентом этой организации.',
  UNVERIFIED_CONTACT_MATCH:
    'Номер пользователя не подтверждён; проверьте привязку клиента.',
  CHAT_DISABLED: 'Чат Рекомендуй отключён в настройках компании.',
  FORBIDDEN: 'Недостаточно прав для работы с этим чатом.',
  NOT_FOUND: 'Диалог или сообщение больше недоступны.',
  INVALID_MESSAGE: 'Отправьте непустой текст до 5000 символов без вложений.',
  IDEMPOTENCY_CONFLICT:
    'Содержимое отправки изменилось. Проверьте сообщение перед новой отправкой.',
  RATE_LIMITED: 'Слишком много запросов. Повторите действие позже.',
  BINDING_CONFLICT:
    'Привязку обращения должен проверить администратор в настройках Рекомендуй.',
  VERSION_CONFLICT:
    'Настройки уже изменены другим сотрудником. Загрузите актуальную версию.',
  CURSOR_EXPIRED: 'Обновите историю диалога.',
  INVALID_REQUEST: 'Проверьте заполненные поля и повторите действие.',
  TEMPORARILY_UNAVAILABLE:
    'Сервис временно недоступен. Повторите действие позже.',
};

export const getRecommendChatErrorCode = (error: unknown): string | null => {
  const text =
    typeof error === 'string'
      ? error
      : error && typeof error === 'object' && 'data' in error
      ? error.data
      : null;

  if (typeof text !== 'string') return null;

  return /^RECOMMEND_([A-Z_]+):/.exec(text)?.[1] ?? null;
};

export const getRecommendChatReason = (
  reasonCode: string | null | undefined
): string =>
  (reasonCode && RECOMMEND_ERROR_MESSAGES[reasonCode]) ||
  'Чат Рекомендуй сейчас недоступен.';

export const getRecommendChatErrorMessage = (
  error: unknown,
  fallback = 'Не удалось выполнить действие в чате Рекомендуй. Повторите позже.'
): string => {
  const code = getRecommendChatErrorCode(error);

  return (code && RECOMMEND_ERROR_MESSAGES[code]) || fallback;
};

export const isRecommendChatRetryableError = (error: unknown): boolean => {
  const code = getRecommendChatErrorCode(error);

  // Unknown transport failures (including timeouts) do not prove rejection.
  return (
    code === null ||
    code === 'TEMPORARILY_UNAVAILABLE' ||
    code === 'RATE_LIMITED'
  );
};
